import { CurrencyCreateInput } from './../../../../types/src/mado/input-type/currency/currency.create-input';
import { CurrencyUpdateInput } from './../../../../types/src/mado/input-type/currency/currency.update-input';
import { CurrencyRateCreateInput } from './../../../../types/src/mado/input-type/currency/currency-rate.create-input';
import { CurrencyRateUpdateInput } from './../../../../types/src/mado/input-type/currency/currency-rate.update-input';
import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import {
    CurrencyGridObject, CurrencyObject,
} from '@libs/types/src/mado/object-type/currency/currency.object';
import { filterFrag } from './types/filter.types';
import { CurrencyRateGridObject, CurrencyRateObject } from '@libs/types/src/mado/object-type/currency/currency-rate.object';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class CurrencyGqlServiceV2 extends GqlServiceV2 {

    public getCurrencies(input: GridInput | null, frag: string) {
        return this.query<CurrencyGridObject>(
            `
                query($input: GridInput!) {
                    currency {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createCurrency(input: CurrencyCreateInput, frag: string) {
        return this.mutate<CurrencyObject>(
            `
                mutation($input: CurrencyCreateInput!) {
                    currency {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateCurrency(input: CurrencyUpdateInput, frag: string) {
        return this.mutate<CurrencyObject>(
            `
                mutation($input: CurrencyUpdateInput!) {
                    currency {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteCurrency(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    currency {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getCurrencyRates(input: GridInput | null, frag: string) {
        return this.query<CurrencyRateGridObject>(
            `
                query($input: GridInput!) {
                    currencyRate {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createCurrencyRate(input: CurrencyRateCreateInput, frag: string) {
        return this.mutate<CurrencyRateObject>(
            `
                mutation($input: CurrencyRateCreateInput!) {
                    currencyRate {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateCurrencyRate(input: CurrencyRateUpdateInput, frag: string) {
        return this.mutate<CurrencyRateObject>(
            `
                mutation($input: CurrencyRateUpdateInput!) {
                    currencyRate {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteCurrencyRate(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    currencyRate {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
